import React from 'react';
import Entry from '../entry';
import { Flex, Text } from 'rebass';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

export default () => {
  const title = 'Mongo Pilfer';
  const hints = [(<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Holly Evergreen] </Text><a href="https://docs.mongodb.com/manual/reference/command/listDatabases/#dbcmd.listDatabases">MongoDB Documentation</a></Flex>),
];
  const assignment = `Hey! It's me, Holly Evergreen! My teacher has been locked out of the quiz database and can't remember the right solution.
Without access to the answer, none of our quizzes will get graded.
Can we help get back in to find that solution?
I tried lsof -i, but that tool doesn't seem to be installed.
I think there's a tool like ps that'll help too. What are the flags I need?
Either way, you'll need to know a teensy bit of Mongo once you're in.
Pretty please find us the solution to the quiz!`;
  const data = useStaticQuery(graphql`
    query {
      cranMongo: file(relativePath: { eq: "cranMongo.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mongoStart: file(relativePath: { eq: "mongoStart.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mongoStep1: file(relativePath: { eq: "mongoStep1.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mongoStep2: file(relativePath: { eq: "mongoStep2.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mongoStep3: file(relativePath: { eq: "mongoStep3.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mongoStep4: file(relativePath: { eq: "mongoStep4.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mongoWin: file(relativePath: { eq: "mongoWin.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }


    }
  `);
  const extra = (
    <>
    <Img fluid={data.cranMongo.childImageSharp.fluid}
            style={{ margin: 0,  maxHeight: '35vh', width: '72vw' }}
            imgStyle={{ objectFit: 'contain' }}
    />
    <Text mb={1} fontSize='13px' alignSelf='center'>Location: Hermey Hall, NetWars Room</Text>
    </>
  );

  return (
    <Entry
      title={title}
      hints={hints}
      extra={extra}
      assignment={assignment}
    >
      <Text my={2}>Nothing new on the starting screen.</Text>
      <Img fluid={data.mongoStart.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>Holly recommended that we use <code>ps</code> command to figure out on which port the database is running. Let's use <code>-a</code>flag to see all processes and <code>-x</code> flag to see processes not attached to the terminal.</Text>
      <Img fluid={data.mongoStep1.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>Good to know that mongo database is running on port 12121. Let's connect to it with mongo shell.</Text>
      <Img fluid={data.mongoStep2.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>Access Control is not enabled! It means we can run admin commands in mongo shell. Like the one to show us all databases.</Text>
      <Img fluid={data.mongoStep3.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>That <code>elfu</code> database sounds like it is university related, so the professor might put the solution here. </Text>
      <Img fluid={data.mongoStep4.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}></Text>
      <Img fluid={data.mongoWin.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '30vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
    </Entry>
  )

};
